import { render, staticRenderFns } from "./CommodityFLowStateList.vue?vue&type=template&id=e54926de&scoped=true&"
import script from "./CommodityFLowStateList.vue?vue&type=script&lang=js&"
export * from "./CommodityFLowStateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54926de",
  null
  
)

export default component.exports